import React from "react";
import {AbsoluteFill, Sequence, Img} from "remotion";
import {AnimatedTitle} from "../../components/text/AnimatedTitle";
import {GradientBackground} from "../../components/backgrounds/GradientBackground";
import {SafeArea} from "../../components/layout/SafeArea";
import {loadDefaultFonts, FONT_FAMILIES} from "../../presets/fonts";
import {Watermark} from "../../components/overlays/Watermark";
import {BRAND} from "../../presets/brand";
import {OrganicLayer} from "../../components/overlays/OrganicLayer";
import {FilmGrain as CinemaGrain, CinemaVignette} from "../../components/overlays/FilmGrain";

export interface TestimonialProps {
  quote?: string;
  author?: string;
  role?: string;
  avatarSrc?: string;
  backgroundColors?: string[];
  accentColor?: string;
}

export const Testimonial: React.FC<TestimonialProps> = ({
  quote = "Your testimonial quote here.",
  author = "Author Name",
  role,
  avatarSrc,
  backgroundColors = ["#0a0a0a", "#1a1a2e"],
  accentColor = "#8b5cf6",
}) => {
  loadDefaultFonts();

  return (
    <OrganicLayer intensity="subtle" seed="testimonial">
    <AbsoluteFill>
      <GradientBackground colors={backgroundColors} angle={135} />

      <SafeArea>
        <AbsoluteFill
          style={{
            justifyContent: "center",
            alignItems: "center",
            padding: "0 120px",
          }}
        >
          {/* Quote mark */}
          <Sequence from={0}>
            <div
              style={{
                fontSize: 120,
                color: accentColor,
                fontFamily: FONT_FAMILIES.elegant,
                opacity: 0.3,
                lineHeight: 0.8,
                marginBottom: -20,
              }}
            >
              &ldquo;
            </div>
          </Sequence>

          {/* Quote text */}
          <Sequence from={10}>
            <AnimatedTitle
              text={quote}
              fontSize={36}
              fontWeight={400}
              fontFamily={FONT_FAMILIES.elegant}
              color="#ffffff"
              enterAnimation="fade"
              enterDuration={30}
              holdDuration={999}
              exitDuration={0}
              lineHeight={1.6}
            />
          </Sequence>

          {/* Author */}
          <Sequence from={40}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 40,
                gap: 16,
              }}
            >
              {avatarSrc && (
                <Img
                  src={avatarSrc}
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 28,
                    objectFit: "cover",
                    border: `2px solid ${accentColor}`,
                  }}
                />
              )}
              <div>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 700,
                    color: "#ffffff",
                    fontFamily: FONT_FAMILIES.heading,
                  }}
                >
                  {author}
                </div>
                {role && (
                  <div
                    style={{
                      fontSize: 16,
                      color: accentColor,
                      fontFamily: FONT_FAMILIES.heading,
                      marginTop: 2,
                    }}
                  >
                    {role}
                  </div>
                )}
              </div>
            </div>
          </Sequence>
        </AbsoluteFill>
      </SafeArea>

      <Watermark text={BRAND.handle} corner="bottomRight" opacity={0.4} fontSize={14} color="#ffffff" />
      <CinemaGrain opacity={0.06} />
      <CinemaVignette opacity={0.5} />
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
